import {BotaoExcluir, PaginaLogada} from "../../componentes";
import React, {useEffect, useState} from "react";
import {exibirMensagemSucesso, getUsuarioLogado, somenteNumeros} from "../../util";
import CardPadrao from "../../componentes/card/card-padrao";
import {Center, Modal, Stack, Table, TextInput} from "@mantine/core";
import {COR} from "../../config/constantes/constantes-mantine";
import {BotaoMantine} from "../../componentes/botao/botao-mantine";
import CursoServico from "../../servicos/curso-servico";
import {Curso} from "../../tipos/curso";
import {useDisclosure, useListState} from "@mantine/hooks";
import {formatarDataHoraLocaleString, formatarTelefone} from "../../util/mascara";
import {IconUserPlus} from "@tabler/icons-react";
import {CadastrarInscricaoCursoCmd} from "../../tipos/cmd/cadastrar-inscricao-curso-cmd";

export default function InscricoesAbertas() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [cursos, handlersCursos] = useListState<Curso>()
  const [cursoSelecionado, setCursoSelecionado] = useState<Curso>()
  const [telefone, setTelefone] = useState('')
  const [modal, {open, close}] = useDisclosure(false);
  const usuarioLogado = getUsuarioLogado()

  function buscarCursos() {
    setIsCarregando(true)
    CursoServico.buscarCursosAbertos()
      .then(dados => handlersCursos.setState(dados))
      .finally(() => setIsCarregando(false))
  }
  function inscreverUsuario() {
    const cmd: CadastrarInscricaoCursoCmd = {
      idCurso: cursoSelecionado?.id!!,
      telefone: telefone
    }
    setIsCarregando(true)
    CursoServico.inscreverCurso(cmd)
      .then(dados => {
        exibirMensagemSucesso("Inscrição realizada com sucesso")
      })
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    buscarCursos()
  }, [])

  return (
    <PaginaLogada titulo="Inscrições" isCarregando={isCarregando}>
      <CardPadrao titulo="Cursos com Inscriçoes Abertas" mt={50}>
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Nome</Table.Th>
              <Table.Th>Descricao</Table.Th>
              <Table.Th>Data Inicio Inscrição</Table.Th>
              <Table.Th>Data Fim Inscrição</Table.Th>
              <Table.Th>Ação</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Thead>
            {cursos.map((c, k) => {
              return (
                <Table.Tr key={k}>
                  <Table.Td>{c.nome}</Table.Td>
                  <Table.Td>{c.descricao}</Table.Td>
                  <Table.Td>{formatarDataHoraLocaleString(c.dataInicioInscricao)}</Table.Td>
                  <Table.Td>{formatarDataHoraLocaleString(c.dataFimInscricao)}</Table.Td>
                  <Table.Td>
                    <BotaoMantine disabled={!c.aberto} icone={IconUserPlus} onClick={() => {open(); setCursoSelecionado(c)}}>
                      Inscrever-se
                    </BotaoMantine>
                  </Table.Td>
                </Table.Tr>
              )
            })}
          </Table.Thead>
        </Table>
      </CardPadrao>

      <Modal opened={modal}
             onClose={close}
             centered
             title={"Tem certeza que deseja se inscrever neste curso?"}
      >
        <Stack gap={'md'} align={"stretch"}>
          <TextInput readOnly label={"Curso"} value={cursoSelecionado?.nome}/>
          <TextInput readOnly label={"Nome"} value={usuarioLogado.nome}/>
          <TextInput readOnly label={"Email"} value={usuarioLogado.email}/>
          <TextInput label={"Telefone"} value={formatarTelefone(telefone)} onChange={(e) => setTelefone(somenteNumeros(e.target.value))}/>
        </Stack>
        <Center mt={30}>
          <BotaoMantine color={COR.SUCESSO} icone={IconUserPlus} onClick={inscreverUsuario} >
            Inscrever
          </BotaoMantine>
        </Center>
      </Modal>
    </PaginaLogada>
  );
}
